module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [(_vm.showList) ? _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "关键词语："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "title": _vm.filters.keyword,
      "placeholder": "搜索联盟名称·联系人·电话",
      "maxlength": "50"
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "状态："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.vipOrderStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "vipOrderStatusId", $$v)
      },
      expression: "filters.vipOrderStatusId"
    }
  }, _vm._l((_vm.statusoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "盟主店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.bbName
          }
        }, [_vm._v(_vm._s(scope.row.bbName))])]
      }
    }], null, false, 2391569220)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "城市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cityName))]
      }
    }], null, false, 1387987293)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联盟名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "LOGO",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticClass: "logoImg",
          attrs: {
            "src": scope.row.logoUrl,
            "alt": "",
            "preview-src-list": [scope.row.logoUrl]
          },
          on: {
            "click": _vm.handleClickItem
          }
        })]
      }
    }], null, false, 2655041441)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联盟联系人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contactsPhone))]
      }
    }], null, false, 1248487762)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请时间",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.time))]
      }
    }], null, false, 2176227688)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.stateName))]
      }
    }], null, false, 2867331277)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.examineRemarks))]
      }
    }], null, false, 2189583807)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showSettlement(scope.row.id, true)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v(" 通过\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showSettlement(scope.row.id, false)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-close"
        }), _vm._v(" 拒绝\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 2) ? _c('span', {
          staticStyle: {
            "color": "#3396fb"
          },
          on: {
            "click": function($event) {
              return _vm.kaiqiguanbi(scope.row.id, scope.row.isSeeAll == false ? true : false)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-data-line"
        }), _vm._v(" " + _vm._s(scope.row.isSeeAll == false ? '开数据' : '关数据') + "\r\n              ")]) : _vm._e()]
      }
    }], null, false, 255444569)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.showList) ? _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('p', {
    staticClass: "reminder",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    staticClass: "faceUrl",
    attrs: {
      "src": _vm.seeLogoUrl
    }
  }), _vm._v(" 联盟名称: " + _vm._s(_vm.seeName) + "　　联盟联系人: " + _vm._s(_vm.seeContacts) + "　　联系电话: " + _vm._s(_vm.seePhone) + "\r\n      ")]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "margin-left": "16px"
    },
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "搜索店铺名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.keyWordTwo),
      callback: function($$v) {
        _vm.keyWordTwo = $$v
      },
      expression: "keyWordTwo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmitTwo
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataListTwo,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }], null, false, 2034370561)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.bbTypeName))]
      }
    }], null, false, 1483970594)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "加入时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }], null, false, 261302795)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexTwo,
      "page-size": 10,
      "total": _vm.totalTwo
    },
    on: {
      "current-change": _vm.handleCurrentChangeTwo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "20px",
      "display": "flow-root"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.returnFun
    }
  }, [_vm._v("返回")])], 1)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "审核",
      "visible": _vm.importantIips,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.importantIips = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "审核备注："
    }
  }, [_c('el-input', {
    staticStyle: {
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    },
    attrs: {
      "placeholder": "请输入审核意见",
      "maxlength": "50"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.importantIips = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("联盟审核")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("审核详情列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5dd0c676!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/platformManagement/merchantAllianceAudit.vue
// module id = 1694
// module chunks = 3